import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class CartService {
  private productList: any[];
  constructor(private storageService: StorageService) {}

  addCart(product: any): boolean {
    try {
      this.productList = this.storageService.getItemArray("cart");
      this.productList.push(product);
      this.storageService.addItem(this.productList, "cart");
      this.storageService.removeItem('product');
    } catch (error) {
      console.log(error);
      return false;
    }
    return true;
  }

  saveProduct(product:any){
    this.storageService.addItem(product,'product');
  }


  getProduct():any{
    return this.storageService.getItem('product');
  }

  getItemsCount(): number {
    let count = 0;
    this.productList = this.storageService.getItemArray("cart");
    count = this.productList.length;
    
    return count;
  }

  getProductList(): any[] {
    this.productList = this.storageService.getItemArray("cart");
    return this.productList;
  }

  refreshProductList(productList: any[]): boolean {
    try {
      this.storageService.addItem(productList, "cart");
    } catch (error) {
      return false;
    }
    return true;
  }

  getTotal(): number {
    let total: number = 0;
    this.productList = this.storageService.getItemArray("cart");
    this.productList.forEach((element) => {
      total +=
        (parseFloat(element.precio) + parseFloat(element.extras)) *
        element.cantidad;
    });
    return total;
  }

  getProductsModifiersString(): string[] {
    let result: string[];
    try {
      this.productList = this.storageService.getItemArray("cart");
      let products: string = "";
      let modifieres: string = "";
      let line: number = 0;
      this.productList.forEach((element) => {
        line += 1;
        if(element.numeroLinea){
          line = element.numeroLinea;
        }
        if (products.length > 0) {
          products +=
            "&" +
            element.codProducto +
            ":" +
            element.cantidad +
            ":" +
            (parseFloat(element.precio) + parseFloat(element.extras)) +
            ":" +
            line +
            ":" +
            element.comentario;
        } else {
          products =
            element.codProducto +
            ":" +
            element.cantidad +
            ":" +
            element.precio +
            ":" +
            line +
            ":" +
            element.comentario;
        }
        if (element.maneja_modificadores == "1") {
          element.modificadores.forEach((item) => {
            item.modificadores.forEach((modificador) => {
              if (modificador.seleccionado) {
                if (modifieres.length > 0) {
                  modifieres +=
                    "," +
                    element.codProducto +
                    ":" +
                    modificador.codModificador +
                    ":" +
                    modificador.nombre +
                    ":" +
                    modificador.costo_adicional +
                    ":" +
                    line+
                    ":"+
                    "0"+
                    ":"+
                    "0"+
                    ":"+
                    element.cantidad +
                    ":"+
                    item.codCategoria;
                } else {
                  modifieres =
                    element.codProducto +//0
                    ":" +
                    modificador.codModificador +//1
                    ":" +
                    modificador.nombre +//2
                    ":" +
                    modificador.costo_adicional +//3
                    ":" +
                    line+//4
                    ":"+
                    "0"+//5
                    ":"+
                    "0"+//6
                    ":"+
                    element.cantidad +//7
                    ":"+
                    item.codCategoria;
                }
              }
            });
          });
        }
      });

      result = [products, modifieres];
    } catch (error) {
      console.log(error);
      return ["", ""];
    }
    return result;
  }

  clearCart() {
    this.storageService.removeItem("cart");
    this.storageService.removeItem("codOrden");
  }

  validateNewProducts(): boolean {
    try {
      this.productList = this.storageService.getItemArray("cart");
      if (this.productList.length > 0) {
        let result = false;
        this.productList.forEach((element) => {
          if (element.procesado == false) {
            result = true;
          }
        });
        return result;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  validateProductsOrderExist(): boolean {
    try {
      this.productList = this.storageService.getItemArray("cart");
      if (this.productList.length > 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  shippedProduct() {
    try {
      this.productList = this.storageService.getItemArray("cart");
      if (this.productList.length > 0) {
        this.productList.forEach((element) => {
          element.procesado = true;
        });
        this.storageService.addItem(this.productList, "cart");
      }
    } catch (error) {}
  }
}
